namespace appn.views.appBuilder.icons {

    class InitArgs {
        canSave: boolean = false;
        iconInfoList: Array<IconInfo> = [];
    }

    let _initArgs: InitArgs;
    let _currentIconSet = emptyString;

    export function init(args: InitArgs): void {
        _initArgs = args;

        addEvents();

        (appn as any).filesUploading = 0;

        appn.icons.init();
        minicolors.init(function(this: any) {
                // Update preview if necessary
                if ($('#colorPreview').length) {
                    const picker = String(this.id);

                    (picker.containsIgnoreCase('Background')) ? minicolors.refreshPreviewBody() : minicolors.refreshPreviewTitle();
                }
            },
            args.canSave);
    }

    function addEvents(): void {
        // Set up the current icon set
        _currentIconSet = String($('#AppConfig_IconSet').val());
        // _currentIconSet will be undefinied when the Icon Sets are disabled for AaaS clients because no drop down will show
        // When disabled we set the IconSet to be the Default value
        if (_currentIconSet === 'undefined')
            _currentIconSet = 'Default';

        $('#AppConfig_IconSet').change(function() {
            const newIconSet = $(this).val() as string;
            $('.fileinput-new.thumbnail img').each(function() {
                const bgImg = $(this).attr('src') as string;
                const bgImglazy = $(this).data('imglazyurl') as string;
                
                if (!bgImg.containsIgnoreCase('Files/Provider')) {
                    const iconName = $(this).closest('.iconInfo').data('icon') as string;
                    let oldPath = _currentIconSet;
                    let oldBgUrl = `Content/icons/${_currentIconSet}`;

                    if (_currentIconSet === 'Default') {
                        oldPath = findIconWithName(_initArgs.iconInfoList, iconName).path;
                        if (oldPath.containsIgnoreCase('Files/'))
                            oldBgUrl = oldPath;
                        else
                            oldBgUrl = 'Content/icons/' + oldPath;
                    }

                    let newPath = newIconSet;
                    let newBgUrl = `Content/icons/${newIconSet}`;

                    if (newIconSet === 'Default') {
                        newPath = findIconWithName(_initArgs.iconInfoList, iconName).path;
                        if (newPath.indexOf('Files/') >= 0)
                            newBgUrl = newPath;
                        else
                            newBgUrl = 'Content/icons/' + newPath;
                    }

                    $(this).attr('src', bgImg.replace(oldBgUrl, newBgUrl));
                    $(this).attr('data-imglazyurl', bgImglazy.replace(oldBgUrl, newBgUrl));
                }
            });
            _currentIconSet = newIconSet;
        });

        $('.iconReset').on('click', function(event) {
            event.preventDefault();

            const iconPath = $(this).closest('.iconInfo').find('input.iconPath');
            const iconName = $(this).closest('.iconInfo').data('icon');
            let newPath = _currentIconSet;

            if (_currentIconSet === 'Default')
                newPath = findIconWithName(_initArgs.iconInfoList, iconName).path;

            newPath = String(iconPath.val()).replace(`Files/Provider/${appn.requestProvider.id}`, newPath);

            if (newPath.containsIgnoreCase('sys_'))
                newPath = newPath.replace('sys_', emptyString);

            iconPath.val(newPath);

            if (!newPath.containsIgnoreCase('Files/'))
                newPath = 'Content/icons/' + newPath;

            $(this).closest('.fileinput')
                .find('.thumbnail')
                .find('img')
                .attr('src', urls.root + newPath);

            $(this).hide();
        });

        ($('.iconUpload') as any).fileupload({
            dataType: 'json',
            change: function(event: Event, data: any) {
                const file = data.files[0];
                const isValidExt = utils.isValidFileExtension(['.png'], file.name);
                const isValidSize = utils.IsValidFileSize(50, file);

                if (!isValidExt || !isValidSize) {
                    // Clear out the bad file
                    const that = this;

                    setTimeout(function() {
                        $(that).closest('.fileinput').find('.btn.fileinput-exists.btn-remove').click();
                    }, 500);
                }

                return isValidExt && isValidSize;
            },
            submit: function(event: Event, data: any) {
                data.formData = {
                    iconname: $(this).closest('.iconInfo').data('icon'),
                    icontype: $(this).closest('.iconInfo').data('icontype')
                };
            },
            send: function() {
                (appn as any).filesUploading++;
            },
            always: function() {
                (appn as any).filesUploading--;
            },
            done: function(event: Event, data: any) {
                if (data.result.error) {
                    appn.fileUploadUtils.fileUploadFailed(data.result.error);
                    return;
                }

                $(this).closest('.iconInfo').find('input.iconPath').val(data.result);
            },
            error: function() {
                appn.fileUploadUtils.fileUploadFailed();
            },
            fail: function(event: Event, data: any) {
                appn.fileUploadUtils.fileUploadFailed();
            }
        });
    }

    function findIconWithName(array: IconInfo[], name: string): IconInfo {
        return array.filter(t => t.name === name)[0];
    }

    interface IconInfo {
        enabled: boolean;
        isSystem: boolean;
        lastUpdated: string;
        name: string;
        path: string;
    }
}
